import { z } from 'zod';

/**
 * 👑 Global Admin Schema
 * Centralized configuration for platform-wide administrative settings.
 * Path: global/admin
 */
export const GlobalAdminSchema = z.object({
  // Meta Ads Configuration
  metaAds: z.object({
    // Record<ownerId, adAccountId>
    mappings: z.record(z.string(), z.string()).default({}),
    lastSyncAt: z.any().optional(),
  }).default({ mappings: {} }),

  // Future global configs can be added here
  systemStatus: z.string().default('operational'),
  
  updatedAt: z.any().optional(),
  updatedBy: z.string().optional(),
});

export type GlobalAdmin = z.infer<typeof GlobalAdminSchema>;
